export default __webpack_public_path__ + "./fonts/csv.67be4365.svg";